// components/Avatar.jsx
import React from "react";

function getInitials(name = "", letters = 2) {
  const clean = String(name).trim();
  if (!clean) return "?";

  const parts = clean.split(/[\s-]+/).filter(Boolean);

  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase().slice(0, letters);
  }

  return clean.slice(0, letters).toUpperCase();
}

const COLORS = [
  { bg: "bg-blue-500", text: "text-white", ring: "ring-white" },
  { bg: "bg-indigo-500", text: "text-white", ring: "ring-white" },
  { bg: "bg-purple-500", text: "text-white", ring: "ring-white" },
  { bg: "bg-pink-500", text: "text-white", ring: "ring-white" },
  { bg: "bg-rose-500", text: "text-white", ring: "ring-white" },
  { bg: "bg-orange-500", text: "text-white", ring: "ring-white" },
  { bg: "bg-amber-500", text: "text-white", ring: "ring-white" },
  { bg: "bg-emerald-500", text: "text-white", ring: "ring-white" },
  { bg: "bg-teal-500", text: "text-white", ring: "ring-white" },
  { bg: "bg-cyan-500", text: "text-white", ring: "ring-white" },
];

function stringToIndex(str, modulo) {
  const s = String(str ?? "");
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = (hash << 5) - hash + s.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash) % modulo;
}

function getColorClasses(key) {
  const idx = stringToIndex(key, COLORS.length);
  return COLORS[idx];
}

export function Avatar({
  name = "",
  seed,
  size = 32,
  letters = 2,
  ring = true,
  ringClassName,
  className = "",
  title,
  style, // ✅ accept style
}) {
  const stableKey = seed ?? name ?? "";
  const { bg, text, ring: defaultRing } = getColorClasses(stableKey);

  return (
    <div
      className={[
        "inline-flex items-center justify-center rounded-full text-xs font-normal",
        bg,
        text,
        ring ? `ring-2 ring-inset ${ringClassName ?? defaultRing}` : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={{
        width: size,
        height: size,
        ...style, // ✅ merge stack styles (marginLeft, zIndex, etc.)
      }}
      title={title ?? name}
      aria-label={name ? `Avatar for ${name}` : "Avatar"}
      role="img"
    >
      {getInitials(name, letters)}
    </div>
  );
}